// =====================================================
// rittencom.js
// =====================================================

// -----------------------------------------------------
// Samshield Liner Scripts
// -----------------------------------------------------
(function () {
  const ROOT_SEL = "[data-samshield-liner]";

  function qsa(sel, root = document) {
    return Array.from(root.querySelectorAll(sel));
  }

  async function addItems(items) {
    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items })
    });

    const data = await res.json().catch(() => ({}));
    if (!res.ok) {
      console.error("Samshield addItems error:", data);
      throw new Error("Cart add failed");
    }
    return data;
  }

  function findCandidateForms(root) {
    const forms = qsa('form[action*="/cart/add"]');
    const near = root.closest(".shopify-section")?.querySelectorAll('form[action*="/cart/add"]');
    const nearForms = near ? Array.from(near) : [];

    const seen = new Set();
    return [...nearForms, ...forms].filter((f) => {
      if (seen.has(f)) return false;
      seen.add(f);
      return true;
    });
  }

  function getVariantIdFromForm(form) {
    const idEl = form.querySelector('input[name="id"], [name="id"]');
    return idEl ? idEl.value : null;
  }

  function init(root) {
    if (!root || root.dataset.samshieldInit === "1") return;
    root.dataset.samshieldInit = "1";

    const configEl = root.querySelector("[data-samshield-liner-config]");
    if (!configEl) return;

    let config;
    try {
      config = JSON.parse(configEl.textContent || "{}");
    } catch (e) {
      console.error("Samshield liner: invalid JSON config", e);
      return;
    }

    const sizeSelect = root.querySelector(".samshield-liner__select");
    const hint = root.querySelector(".samshield-liner__hint");
    const selectedVariant = root.querySelector("[data-samshield-selected-variant]");
    const radios = qsa('input[type="radio"][data-liner-handle]', root);

    if (!sizeSelect || !selectedVariant || radios.length === 0) return;

    function setHint(text, type) {
      if (!hint) return;
      const msg = (text || "").toString().trim();
      hint.textContent = msg;
      hint.classList.toggle("is-visible", !!msg);
      hint.classList.toggle("is-error", type === "error");
    }

    function resetSizes() {
      sizeSelect.innerHTML = `<option value="">${config.strings?.pickTypeFirst || "Choose a liner type first."}</option>`;
      sizeSelect.disabled = true;
      selectedVariant.value = "";
      setHint("", "");
    }

    function populateSizes(handle) {
      const liner = (config.liners || []).find((l) => l.handle === handle);
      if (!liner) return resetSizes();

      const prompt = config.strings?.sizePrompt || "Make a choice";
      const outOfStockText = config.strings?.outOfStock || "Out of stock";

      sizeSelect.innerHTML =
        `<option value="">${prompt}</option>` +
        liner.variants.map(v => {
          const suffix = v.available ? "" : ` - ${outOfStockText}`;
          return `<option value="${v.id}" ${v.available ? "" : "disabled"}>${v.title}${suffix}</option>`;
        }).join("");

      sizeSelect.disabled = false;
      selectedVariant.value = "";
      setHint("", "");

      const firstAvailable = liner.variants.find(v => v.available);
      if (firstAvailable) {
        sizeSelect.value = String(firstAvailable.id);
        selectedVariant.value = String(firstAvailable.id);
      }
    }

    resetSizes();

    radios.forEach(r =>
      r.addEventListener("change", () => populateSizes(r.dataset.linerHandle || r.value))
    );

    sizeSelect.addEventListener("change", () => {
      selectedVariant.value = sizeSelect.value || "";
    });

    const preChecked = radios.find(r => r.checked);
    if (preChecked) populateSizes(preChecked.dataset.linerHandle || preChecked.value);

    const forms = findCandidateForms(root);
    if (!forms.length) return;

    async function handleAdd(e, form) {
      const linerVariantId = selectedVariant.value;
      if (!linerVariantId) {
        e.preventDefault();
        e.stopImmediatePropagation();
        setHint(config.strings?.requiredError || "Please choose liner type and size.", "error");
        sizeSelect.focus();
        return;
      }

      const helmetVariantId = getVariantIdFromForm(form);
      if (!helmetVariantId) {
        e.preventDefault();
        e.stopImmediatePropagation();
        setHint(config.strings?.requiredError || "Could not detect selected helmet variant.", "error");
        return;
      }

      e.preventDefault();
      e.stopImmediatePropagation();

      try {
        await addItems([
          { id: Number(helmetVariantId), quantity: 1 },
          { id: Number(linerVariantId), quantity: 1, properties: { _bundle: "samshield_free_liner" } }
        ]);

        document.dispatchEvent(new CustomEvent("dispatch:cart-drawer:refresh", { bubbles: true }));
        document.dispatchEvent(new CustomEvent("dispatch:cart-drawer:open"));

        if (window.TC?.campaignBadges?.run) {
          window.TC.campaignBadges.run({ force: true });
        }

        setHint("", "");
      } catch (err) {
        console.error(err);
        setHint(config.strings?.requiredError || "Something went wrong.", "error");
      }
    }

    forms.forEach(form => {
      form.addEventListener("submit", e => {
        const s = e.submitter;
        if (s && (s.name === "checkout" || s.classList.contains("shopify-payment-button__button"))) return;
        handleAdd(e, form);
      }, true);

      form.addEventListener("click", e => {
        const btn = e.target.closest('button[type="submit"], input[type="submit"]');
        if (!btn) return;
        if (btn.name === "checkout" || btn.classList.contains("shopify-payment-button__button")) return;
        handleAdd(e, form);
      }, true);
    });
  }

  function initAll() {
    qsa(ROOT_SEL).forEach(init);
  }

  document.readyState === "loading"
    ? document.addEventListener("DOMContentLoaded", initAll)
    : initAll();

  document.addEventListener("shopify:section:load", initAll);
})();

// -----------------------------------------------------
// Campaign badges, coupon-code driven
// -----------------------------------------------------
(function () {
  const DEBUG = /(?:\?|&)campdebug=1\b/.test(location.search);
  const log = (...a) => DEBUG && console.info("[campaign-badges]", ...a);

  window.TC = window.TC || {};
  window.TC.campaignBadges = window.TC.campaignBadges || {};

  const STORAGE_KEY = "tc_active_campaign_code";
  let cacheCode = "";
  let cacheAt = 0;
  const CACHE_MS = 60000;

  function normalizeCode(v) {
    return String(v || "").trim().toUpperCase();
  }

  function looksLikeCampaign(code) {
    return /^WINTERSALE/i.test(code);
  }

  function safeSessionGet() {
    try {
      return normalizeCode(sessionStorage.getItem(STORAGE_KEY) || "");
    } catch (e) {
      return "";
    }
  }

  function safeSessionSet(code) {
    try {
      sessionStorage.setItem(STORAGE_KEY, code);
    } catch (e) {}
  }

  function safeSessionClear() {
    try {
      sessionStorage.removeItem(STORAGE_KEY);
    } catch (e) {}
  }

  function clearAllActiveCodeState() {
    cacheCode = "";
    cacheAt = 0;
    safeSessionClear();
  }

  function codeFromCookies() {
    try {
      const raw = document.cookie || "";
      if (!raw) return "";
      const m = raw.match(/\bWINTERSALE[0-9A-Z_-]*\b/i);
      return m ? normalizeCode(m[0]) : "";
    } catch (e) {
      return "";
    }
  }

  function captureDiscountLinkClicks() {
    if (document.documentElement.dataset.tcDiscCapture === "1") return;
    document.documentElement.dataset.tcDiscCapture = "1";

    document.addEventListener(
      "click",
      (e) => {
        const a = e.target.closest && e.target.closest("a[href]");
        if (!a) return;

        const href = a.getAttribute("href") || "";
        const m = href.match(/\/discount\/([^?/#]+)/i);
        if (!m || !m[1]) return;

        const parts = m[1].split(",").map((s) => normalizeCode(s));
        const code = parts.find(looksLikeCampaign) || "";
        if (!code) return;

        safeSessionSet(code);
        cacheCode = code;
        cacheAt = Date.now();
        log("captured code from click:", code);
      },
      true
    );
  }

  function tagIconSVG() {
    const clipId = "tc_discount_clip_" + Math.random().toString(36).slice(2, 10);

    return `
      <svg class="campaign-label__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" fill="none"
        stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"
        focusable="false" aria-hidden="true">
        <g stroke-linejoin="round" clip-path="url(#${clipId})">
          <path stroke-linecap="round" d="M10.5 1.5H7.93a2.5 2.5 0 0 0-1.8.766L1.52 7.052a1.5 1.5 0 0 0 .02 2.101l3.48 3.48a1.25 1.25 0 0 0 1.75.016l5.116-4.926a2 2 0 0 0 .613-1.441V3.5a2 2 0 0 0-2-2"></path>
          <circle cx="9.5" cy="4.5" r="0.563" stroke-linecap="round"></circle>
          <path d="M9.49 4.49h.02v.02h-.02z"></path>
        </g>
        <defs>
          <clipPath id="${clipId}">
            <path fill="#fff" d="M0 0h14v14H0z"></path>
          </clipPath>
        </defs>
      </svg>`;
  }

  function extractCodes(cart) {
    const out = new Set();
    if (Array.isArray(cart.discount_codes)) {
      cart.discount_codes.forEach((d) => d?.code && out.add(normalizeCode(d.code)));
    }
    if (Array.isArray(cart.cart_level_discount_applications)) {
      cart.cart_level_discount_applications.forEach((d) => d?.title && out.add(normalizeCode(d.title)));
    }
    return Array.from(out);
  }

  function activeCampaignCode(codes) {
    return codes.find(looksLikeCampaign) || "";
  }

  async function fetchCartActiveCode() {
    const res = await fetch("/cart.js", { credentials: "same-origin", cache: "no-store" });
    if (!res.ok) return "";
    const cart = await res.json();
    return activeCampaignCode(extractCodes(cart));
  }

  async function getActiveCode(force) {
    const now = Date.now();

    if (force) {
      try {
        const code = await fetchCartActiveCode();
        if (code) {
          cacheCode = code;
          cacheAt = now;
          safeSessionSet(code);
          log("active code from cart, force:", code);
          return code;
        }

        clearAllActiveCodeState();
        log("no active code in cart, force, cleared state");
        return "";
      } catch (e) {
        log("cart fetch error, force", e);
      }
    }

    if (cacheCode && now - cacheAt < CACHE_MS) return cacheCode;

    const stored = safeSessionGet();
    if (stored && looksLikeCampaign(stored)) {
      cacheCode = stored;
      cacheAt = now;
      return stored;
    }

    const fromCookie = codeFromCookies();
    if (fromCookie && looksLikeCampaign(fromCookie)) {
      cacheCode = fromCookie;
      cacheAt = now;
      safeSessionSet(fromCookie);
      log("active code from cookie:", fromCookie);
      return fromCookie;
    }

    try {
      const code = await fetchCartActiveCode();
      if (code) {
        cacheCode = code;
        cacheAt = now;
        safeSessionSet(code);
        log("active code from cart:", code);
        return code;
      }

      clearAllActiveCodeState();
      log("no active code in cart, cleared state");
      return "";
    } catch (e) {
      log("cart fetch error", e);
    }

    cacheCode = "";
    cacheAt = now;
    return "";
  }

  function ensureContainer(block) {
    let c = block.querySelector(".product-label-container");
    if (c) return c;

    const media =
      block.querySelector(".product-block__media") ||
      block.querySelector(".product-block__image-wrapper") ||
      block.querySelector(".product-block__image-container") ||
      block.querySelector('a[href*="/products/"]') ||
      block;

    if (media && getComputedStyle(media).position === "static") {
      media.style.position = "relative";
    }

    c = document.createElement("div");
    c.className = "product-label-container product-label-container--campaign";
    media.appendChild(c);
    return c;
  }

  function clearRenderedBadges() {
    document.querySelectorAll(".product-label-container--campaign").forEach((c) => c.remove());
    document.querySelectorAll(".pdp-campaign-label").forEach((el) => {
      el.innerHTML = "";
      el.style.display = "none";
    });
  }

  function render(activeCode) {
    clearRenderedBadges();
    if (!activeCode) return;

    document.querySelectorAll(".product-block[data-campaign-expected-discount]").forEach((block) => {
      const mf = normalizeCode(block.getAttribute("data-campaign-expected-discount") || "");
      if (!mf || mf !== activeCode) return;

      const c = ensureContainer(block);
      c.innerHTML = `
        <span class="product-label product-label--campaign">
          ${tagIconSVG()}
          <span class="campaign-label__text">${mf}</span>
        </span>`;
    });

    document.querySelectorAll(".pdp-campaign-label[data-campaign-expected-discount]").forEach((el) => {
      const mf = normalizeCode(el.getAttribute("data-campaign-expected-discount") || "");
      if (!mf || mf !== activeCode) return;

      el.innerHTML = `
        <span class="product-label product-label--campaign">
          ${tagIconSVG()}
          <span class="campaign-label__text">${mf}</span>
        </span>`;
      el.style.display = "block";
    });
  }

  async function run(opts = {}) {
    captureDiscountLinkClicks();
    const code = await getActiveCode(Boolean(opts.force));
    log("render with code:", code);
    render(code);
  }

  window.TC.campaignBadges.run = run;

  function boot() {
    run();
    setTimeout(() => run({ force: true }), 800);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  document.addEventListener("dispatch:cart-drawer:refresh", () => run({ force: true }));

  window.addEventListener("focus", () => run({ force: true }));
  document.addEventListener("visibilitychange", () => {
    if (!document.hidden) run({ force: true });
  });
})();

// -----------------------------------------------------
// Infinite scroll hook, re-run campaign badges after append
// -----------------------------------------------------
(function () {
  document.addEventListener("rittencom:infinite-scroll:loaded", () => {
    if (window.TC?.campaignBadges?.run) {
      window.TC.campaignBadges.run({ reason: "infinite-scroll:append" });
    }
  });
})();